// extracted by mini-css-extract-plugin
export default {"Loading":"Loading_Loading__6KY-H","Spinner":"Loading_Spinner__GRzw7"};